/**
 * Replaces {{ company_name }} wildcard with actual company name.
 * This is a one-time replacement applied when loading templates.
 *
 * @param text - The text containing the wildcard
 * @param companyName - The actual company name to replace with
 * @returns Text with company_name wildcard replaced
 */
export const replaceCompanyNameWildcard = (
  text: string,
  companyName: string
): string => {
  return text.replace(/\{\{\s*company_name\s*\}\}/g, companyName);
};
